

// import axios from 'axios';

// const BASE_URL = process.env.REACT_APP_API_URL;

// export const updateOnboardingStatus = async (preparation_year, upsc_journey_stage) => {
//   const accessToken = localStorage.getItem('access_token');
//   if (!accessToken) return Promise.reject("Unauthorized");

//   const payload = {
//     preparation_year,
//     upsc_journey_stage
//   };


//   try {
//     const response = await axios.get(`${BASE_URL}//authentication/update-onboarding-status`, payload,{
//       headers: {
//         'accept': 'application/json',
//         Authorization: `Bearer ${accessToken}`,
//       }
//     });
//     return response.data;
//   } catch (error) {
//     console.error('API Error:', error);
//     return Promise.reject(error.response?.data || error.message);
//   }
// };






import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL;

export const updateOnboardingStatus = async (preparation_year, upsc_journey_stage) => {
  const accessToken = localStorage.getItem('access_token');
  if (!accessToken) return Promise.reject("Unauthorized");

  const payload = {
    preparation_year,
    upsc_journey_stage
  };

  try {
    const response = await axios.post(`${BASE_URL}authentication/update-onboarding-status`, payload, {
      headers: {
        'accept': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      }
    });
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    return Promise.reject(error.response?.data || error.message);
  }
};
